import { render, staticRenderFns } from "./Managment.vue?vue&type=template&id=26dbf6c1"
import script from "./Managment.vue?vue&type=script&lang=js"
export * from "./Managment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports